import { Input, Component } from "@angular/core";
import { Panel } from "../../shared/models";
import { VisualObjectComponent } from "./visualObjectComponent";
import { ConfigurationSessionManager } from "../providers/configurationSessionManager";
import { BaseEntity } from "../../shared/baseEntity";
import { DataRowView, DataCellView } from "../../../shared/components/shared";
import { ManagedSubscription } from "../../../shared/managedSubscription";
import { ConfiguratorStore, ConfPageSessionService } from "../providers";
import { ImageSets } from "../../../shared/utils/imageSets";
import { VisualObjectHelper } from "../parameters/shared";

@Component({ template: '' })
export abstract class PanelComponent<T extends Panel> extends VisualObjectComponent {

  @Input()
  public panel: T;

  // Note! Move it to visualObjectComponent if parameters are also expandable.
  @Input()
  public growVisualObject: boolean = false;

  public width: string;
  public minWidth: string;
  public rows: Array<DataRowView> = [];

  @Input()
  public showTitle?: boolean;

  public confPanelSubscription: ManagedSubscription;

  public imageSet: string;

  constructor(public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    public visualObjectHelper: VisualObjectHelper
) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  ngOnInit() {
    this.width = this.visualObjectHelper.visualObjectWidth(this.panel);
    this.minWidth = this.visualObjectHelper.panelsMinWidth(this.panel);

    this.imageSet = this.getImageSet(ImageSets.ConfiguratorPanelHeader);

    if (this.showTitle == null)
      this.showTitle = this.panel.title != null && this.panel.title.trim() != '';

    super.ngOnInit();
  }

  public listenChanges(): void {

    this.confStore.onConfPanelValuesChange(this.configurationId, this.confPageSessionService.confSessionId, this.panel.visualObjectId, this.itemIds,
      (valuesById: Map<number, BaseEntity>): void => {
        this.setValue(valuesById);
      }).unsubscribeOn(this.unsubscribeSubject);
  }

  ngOnDestroy() {    
    super.ngOnDestroy();
  }
    
  public get itemIds(): number[] {
    return [];
  }

  setValue(itemValues: Map<number, any>): void {

  }
}